import { SupplierEdit } from 'components/Suppliers/SupplierEdit';

export const HotelEdit: React.FC = () => <SupplierEdit />;
